import { render, staticRenderFns } from "./splitOrderSetting.vue?vue&type=template&id=67a721db"
import script from "./splitOrderSetting.vue?vue&type=script&lang=ts"
export * from "./splitOrderSetting.vue?vue&type=script&lang=ts"
import style0 from "./splitOrderSetting.vue?vue&type=style&index=0&id=67a721db&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports